import { render, staticRenderFns } from "./DialogAddLesson.vue?vue&type=template&id=6d656251"
import script from "./DialogAddLesson.vue?vue&type=script&lang=js"
export * from "./DialogAddLesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d656251')) {
      api.createRecord('6d656251', component.options)
    } else {
      api.reload('6d656251', component.options)
    }
    module.hot.accept("./DialogAddLesson.vue?vue&type=template&id=6d656251", function () {
      api.rerender('6d656251', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogAddLesson.vue"
export default component.exports